import { expenseDetailsRoutes } from './features/expense-details/expense-details.routes';
import { expensesListingRoutes } from './features/expenses-listing/expenses-listing.routes';

export const expensesRoutes = [
  {
    path: '/expenses',
    name: 'expenses',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "expenses" */ './Expenses.vue'),
    children: [
      {
        path: 'batch-update',
        name: 'expenses-batch-update',
        component: () =>
          import(/* webpackChunkName: "time-sheet-batch-update" */ '../../features/batch-update/BatchUpdateListing.vue')
      },
      ...expensesListingRoutes,
      ...expenseDetailsRoutes
    ]
  }
];
